import { useParams } from '@xing-com/crate-core-router';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class CompaniesFrontend implements Xinglet {
  public getComponent() {
    return (): JSX.Element => {
      const { slug } = useParams();

      return <App pageSlug={slug} />;
    };
  }
}
